import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input} from 'reactstrap';
import './css/View.css';
import CustomFilters from './CustomFilters';

const SearchBar = (props) => {
    const { value, onKeyUp, filterSearch, onClick } = props;
    return (
        <div title="" className="input-icons">
            <i className="icon">
                <FontAwesomeIcon icon="search" size="sm" className="awesome-icon" color="#99A3A4" />
            </i>
            <i className=""></i>
            <form onSubmit={e => { e.preventDefault(); }} className="formis">
                <Input id="search-input" name="search" title="" required className="input-field search-box" type="text" defaultValue={value ? value : ""}  onKeyUp={onKeyUp} onChange={filterSearch} />
                <button className="close-icon" type="reset" onClick={onClick}></button>
            </form>
            {props.customFilters ? 
                <CustomFilters 
                    onlyActiveFilterLabel={props.customFilters.onlyActiveFilterLabel}
                    onlyActiveOnChange={props.customFilters.onlyActiveOnChange}
                    showOnlyActiveFilter={props.customFilters.showOnlyActiveFilter}
                /> 
                : 
                <></>
            }
        </div>
    );
}

export default SearchBar;